export default __webpack_public_path__ + "static/media/664.729e6705.png";